import { Component, EventEmitter, OnInit, Output, inject, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { filter, tap } from 'rxjs';
import { Purpose } from 'src/app/core/models/purpose';
import { AskConfirmationDialogComponent } from '../../../shared/components/ask-confirmation-dialog/ask-confirmation-dialog.component';
import { EventsService } from '../../services/events-service';
import { PurposeComponent } from '../purpose/purpose.component';
import { TranslateModule } from '@ngx-translate/core';

// app-purposes component has too many responsabilities, extract some in this component
@Component({
    selector: 'app-purposes-list[purposes][tenantId]',
    template: `
    @for (purpose of filteredPurposes(purposes()); track purpose._id.$oid; let i = $index) {
      <app-purpose [isReadOnly]="isReadonly()" [purpose]="purpose" [purposeIndex]="i" (remove)="remove(i)"/>
    } @empty {
      <p>{{ 'purposes-list.component.nessun-finalita-di-b' | translate }}</p>
    }
    `,
    imports: [PurposeComponent, TranslateModule]
})
export class PurposesListComponent<T extends Purpose> implements OnInit {
  private dialog = inject(MatDialog);

  readonly purposes = input.required<T[]>();

  readonly isReadonly = input<boolean>(false);

  readonly tenantId = input.required<string>();

  @Output() purposesChange!: EventEmitter<T[]>;

  @Output() purposeChange!: EventEmitter<T>;

  readonly showDeletedPuroposes = input(false);

  constructor() {
    const eventsSrv = inject<EventsService<T>>(EventsService);

    this.purposesChange = eventsSrv.purposesChangeEmitter();
    this.purposeChange = eventsSrv.purposeChangeEmitter();
  }

  ngOnInit(): void {
    // on new benefit, add it to the list of benefits
    this.purposeChange.pipe(
      filter((d) => !!d),
      filter(p => this.purposes().filter(ep => ep._id.$oid === p._id.$oid).length === 0),
      tap((data) => this.purposes().push(data))
    ).subscribe();

    // on new benefit, add it to the list of benefits
    this.purposeChange.pipe(
      filter((d) => !!d),
      tap(p => this.purposes().map(ep => p._id.$oid === ep._id.$oid ? p : ep))
    ).subscribe();
  }

  remove(index: number) {
    const { title } = this.purposes()[index];
    if (title) {
      this.dialog
        .open(AskConfirmationDialogComponent, {
          data: {
            resource: this.filteredPurposes(this.purposes())[index].title,
            type: 'PURPOSE'
          },
        })
        .afterClosed()
        .pipe(
          filter((resp) => !!resp),
          tap((response) => {
            if (response) {
              (response as Date).setHours(12);
              this.filteredPurposes(this.purposes())[index].deletedFrom = response;
              this.purposesChange.emit(this.purposes());
            }
          })
        )
        .subscribe();
    } else {
      this.purposes().splice(index, 1);
    }
  }

  filteredPurposes(purposes: Purpose[]): Purpose[] {
    return this.showDeletedPuroposes()
      ? purposes
      : purposes.filter(p => !p.deletedFrom);
  }
}
